import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';

function DynamicTitle() {
    const location = useLocation();
    const [pageMeta, setPageMeta] = useState({
        title: 'Centro Partner - Psicopatici.com',
        description: 'Welcome to Psicopatici, your trusted partner in website management and optimization.',
        keywords: 'Psicopatici, Website Management, Digital Tools, Optimization',
        image: 'https://partner.psicopatici.com/assets/images/home-image.png',
        url: 'https://partner.psicopatici.com/',
    });

    useEffect(() => {
        const fetchArticleMeta = async (slug) => {
            try {
                const response = await fetch(`https://your-api-url.com/articles/${slug}`);
                const data = await response.json();

                setPageMeta({
                    title: `${data.title} - Psicopatici.com`,
                    description: data.description,
                    keywords: data.keywords,
                    image: data.image,
                    url: `https://partner.psicopatici.com/article/${slug}`,
                });
            } catch (error) {
                console.error('Error fetching article meta:', error);
            }
        };

        const getPageMeta = (pathname) => {
            switch (pathname) {
                case '/':
                    return {
                        title: 'Centro Partner - Psicopatici.com',
                        description: 'Welcome to Psicopatici, your trusted partner in website management and optimization.',
                        keywords: 'Psicopatici, Website Management, Digital Tools, Optimization',
                        image: 'https://partner.psicopatici.com/assets/images/home-image.png',
                        url: 'https://partner.psicopatici.com/',
                    };
                case '/virtualinfluencer':
                    return {
                        title: 'Virtual Influencer - Psicopatici.com',
                        description: 'Welcome to Psicopatici, your trusted partner in website management and optimization.',
                        keywords: 'Psicopatici, Website Management, Digital Tools, Optimization',
                        image: 'https://partner.psicopatici.com/assets/images/home-image.png',
                        url: 'https://partner.psicopatici.com/',
                    };
                case '/totemtouch':
                    return {
                        title: 'Totem Touch - Psicopatici.com',
                        description: 'Welcome to Psicopatici, your trusted partner in website management and optimization.',
                        keywords: 'Psicopatici, Website Management, Digital Tools, Optimization',
                        image: 'https://partner.psicopatici.com/assets/images/home-image.png',
                        url: 'https://partner.psicopatici.com/',
                    };
                case '/thankspage':
                    return {
                        title: 'Iscrizione alla newsletter - Psicopatici.com',
                        description: 'Welcome to Psicopatici, your trusted partner in website management and optimization.',
                        keywords: 'Psicopatici, Website Management, Digital Tools, Optimization',
                        image: 'https://partner.psicopatici.com/assets/images/home-image.png',
                        url: 'https://partner.psicopatici.com/',
                    };
                case '/articles':
                    return {
                        title: 'Articles - Psicopatici.com',
                        description: 'Explore our wide range of articles and resources on website management.',
                        keywords: 'Articles, Psicopatici, Resources, Website Management',
                        image: 'https://partner.psicopatici.com/assets/images/articles-image.png',
                        url: 'https://partner.psicopatici.com/articles',
                    };
                case '/landingpage':
                    return {
                        title: 'LandingPage - Psicopatici.com',
                        description: 'Explore our wide range of articles and resources on website management.',
                        keywords: 'Articles, Psicopatici, Resources, Website Management',
                        image: 'https://partner.psicopatici.com/assets/images/articles-image.png',
                        url: 'https://partner.psicopatici.com/articles',
                    };
                    case '/roadmap':
                        return {
                            title: 'Roadmap - Psicopatici.com',
                            description: 'Explore our wide range of articles and resources on website management.',
                            keywords: 'Articles, Psicopatici, Resources, Website Management',
                            image: 'https://partner.psicopatici.com/assets/images/articles-image.png',
                            url: 'https://partner.psicopatici.com/articles',
                        };
                default:
                    if (pathname.startsWith('/article/')) {
                        const slug = pathname.split('/article/')[1];
                        fetchArticleMeta(slug);
                        return pageMeta; // Temporary until the data is fetched
                    }
                    return {
                        title: 'Psicopatici Partners',
                        description: 'Explore our partnership program.',
                        keywords: 'Psicopatici, Partners, Psicopatici Partner',
                        image: '',
                        url: 'https://partner.psicopatici.com',
                    };
            }
        };

        const meta = getPageMeta(location.pathname);
        if (!location.pathname.startsWith('/article/')) {
            setPageMeta(meta);
        }
    }, [location.pathname]);

    const { title, description, keywords, image, url } = pageMeta;

    return (
        <Helmet>
            {/* Meta tag di base */}
            <title>{title}</title>
            <meta name="description" content={description} />
            <meta name="keywords" content={keywords} />
            <meta name="author" content="Renatia" />
            <meta name="robots" content="index, follow" />
            <link rel="canonical" href={url} />

            {/* Meta tag per i social network - Open Graph */}
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:type" content="website" />
            <meta property="og:url" content={url} />
            <meta property="og:image" content={image} />
            <meta property="og:site_name" content="Psicopatici" />

            {/* Meta tag per Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image} />
            <meta name="twitter:site" content="@Psicopatici" />

            {/* Meta tag di compatibilità e mobile */}
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta http-equiv="X-UA-Compatible" content="IE=edge" />
        </Helmet>
    );
}

export default DynamicTitle;
